import { Component, inject, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FeatureFlagController } from '@domain';
import { RaButtonComponent } from '@shared/components';
import { RaModalComponent } from 'src/app/shared/components/ra-modal/ra-modal.component';
import { DocumentItemComponent } from './document-item/document-item.component';

/** Etapa visível do menu: tipos de documento ou sub-opções de contrato. */
type CreateDocumentStep = 'root' | 'contract';

@Component({
    selector: 'create-document-options',
    templateUrl: 'create-document-options.component.html',
    styleUrl: 'create-document-options.component.scss',
    imports: [DocumentItemComponent, RaButtonComponent, RaModalComponent, TranslatePipe],
})
export class CreateDocumentOptionsComponent {
    public createBlankDocument = output();
    public createBlankContract = output();
    public useInternalTemplate = output();
    public createQuote = output();
    public importFiles = output();
    public close = output();

    public featureFlagController = inject(FeatureFlagController);

    /** Etapa atual. Reinicia em 'root' a cada abertura (o componente é recriado). */
    protected readonly step = signal<CreateDocumentStep>('root');
}
